import {useBoolean} from 'usehooks-ts'

import {useFragmentHelpers} from '@sdox/api'
import {Button} from '@sdox/ui'

import {getIcon, sizeMap, variantMap} from '../utils'
import {NestedContentDrawer} from './NestedContentDrawer'

import type {TrackingProps} from '@sdox/utils/dom'
import type {ButtonInterface_NestedContentButtonType_Fragment, PanelFragment} from '@sdox/api'

type NestedContentButtonProps = ButtonInterface_NestedContentButtonType_Fragment

export const NestedContentButton = (props: NestedContentButtonProps) => {
  const {size, label, variant, leadingIcon, trailingIcon, panelId, panel: panelData, mboAttrs} = props
  const {usePanel} = useFragmentHelpers()
  const panel = usePanel(panelId, panelData as PanelFragment)

  const {
    setTrue: openDialog,
    setFalse: closeDialog,
    value: isOpen,
  } = useBoolean(false)

  if (!panel) return null

  return (
    <>
      <Button
        size={sizeMap[size]}
        variant={variantMap[variant]}
        leading={getIcon(leadingIcon)}
        trailing={getIcon(trailingIcon)}
        onClick={openDialog}
        mboAttrs={mboAttrs as TrackingProps}
      >
        {label}
      </Button>
      <NestedContentDrawer
        isOpen={isOpen}
        onClose={closeDialog}
        panel={panel}
      />
    </>
  )
}
